export default __webpack_public_path__ + "static/20_9-8fd3efbad5329d83a238765fffecf783.png";